import React from "react";
import './You.css'

const You = () => {
    return (
        <div className="in">
            <h1>You are in good hands</h1>
            <p>“There is nothing more important than a good, safe, secure home.” “Home is a place you grow up wanting to leave, and grow old wanting to get back to.” “There's no place like home.” “Where we love is home- home that our feet may leave, but not our hearts.”</p>
        </div>
    )
}

export default You